export default __webpack_public_path__ + "static/media/ico-connect-station.d0874707.svg";